import { render, staticRenderFns } from "./report51.vue?vue&type=template&id=0b4ad9c2&scoped=true"
import script from "./report51.vue?vue&type=script&lang=js"
export * from "./report51.vue?vue&type=script&lang=js"
import style0 from "./report51.vue?vue&type=style&index=0&id=0b4ad9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ad9c2",
  null
  
)

export default component.exports